// Open only organisation route families; preserve separately held products.
export function organisationLaunchLane(path){
 if(typeof path!=='string')return null;
 try{if(decodeURIComponent(path)!==path)return null;}catch{return null;}
 if(/\/(practice-team|prepare-sponsor-payment|sponsor-payment|payout-preferences|sick-notes?|tests|labs)(\/|$)/i.test(path))return null;
 if(/^\/regional-health(?:\/|$)/.test(path))return null;
 if(/^\/pharmac(?:y|ies)(?:\/|$)/.test(path))return 'pharmacy';
 if(/^\/institutions(?:\/|$)/.test(path))return 'institution';
 return null;
}
